export default __webpack_public_path__ + "static/media/cannotaccess.a22a4e4c.png";